import { mediaQuery } from 'constants/ui';

const footerStyles = {
  marginTop: 'auto',
};

export const getFooterDividerStyles = isScrolled => ({
  ...footerStyles,
  borderTop: isScrolled ? ({ palette }) => `1px solid ${palette.border.default}` : 'none',
  padding: '12px 16px 16px',
  paddingBottom: 'calc(16px + env(safe-area-inset-bottom))',
  [mediaQuery.mobile]: {
    padding: '8px 12px 12px',
    paddingBottom: 'calc(12px + env(safe-area-inset-bottom))',
  },
});
